import { PurchasePolicyInput } from 'src/redux/reducer/v2/purchasePolicy';

interface BuildingAddressPartsArgs {
  address: PurchasePolicyInput['address'];
  buildingAddress: PurchasePolicyInput['buildingAddress'];
}

interface BuildingAddressPartsResult {
  addressPart1: string;
  addressPart2: string;
}

export const getBuildingAddressParts = ({
  address,
  buildingAddress,
}: BuildingAddressPartsArgs): BuildingAddressPartsResult => {
  if (!address && !buildingAddress) {
    return {
      addressPart1: '',
      addressPart2: '',
    };
  }

  const usedAddress = address || buildingAddress.value;

  const addressNumber = usedAddress.addressNumber ?? '';
  const addressStreet = usedAddress.street ?? '';
  const addressCity = usedAddress.municipality ?? '';
  const addressState = usedAddress.state ?? '';
  const addressZipCode = usedAddress.postalCode ?? '';

  return {
    addressPart1: `${addressNumber} ${addressStreet}`.trim(),
    addressPart2: `${addressCity}, ${addressState} ${addressZipCode}`.trim(),
  };
};
